__turbopack_context__.v({
  "media": "TabContent-module-scss-module__Xy9NzG__media",
  "media-container": "TabContent-module-scss-module__Xy9NzG__media-container",
});
